var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-form-group',_vm._g(_vm._b({attrs:{"label":_vm.gLabel,"description":_vm.gDescription},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("label")]},proxy:true}],null,true)},'b-form-group',_vm.repProps,false),_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }